import React from 'react';
import './App.css';
import Chatbot from './Chatbot';

// Renders basic web app features
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1 className="app-title">Chatbot for Cloud-Based High Performance Computing (HPC)</h1>
        <p className="app-description">
        A retrieval-augmented generation (RAG) chatbot built with Pinecone + Azure OpenAI that provides advice for HPC on AWS and Azure, offering practical examples and cloud deployment guidance grounded in official case studies and documentation from both providers.
        </p>
      </header>
      {/* <main> gives screen reader users a landmark to jump straight to the
          chatbot, skipping past the header on repeat visits. */}
      <main>
        <Chatbot />
      </main>
    </div>
  );
}

export default App;
